import {PayloadAction} from "../payload-action.interface";
import {ProtocolEntity} from "./protocol.entity";
import {ProtocolActions} from "./protocol.actions";

export function ProtocolReducer(state: Array<ProtocolEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case ProtocolActions.REMOVE:
      return removeProtocol(state, action.payload);
    case ProtocolActions.ADD:
    case ProtocolActions.SET:
      newState = removeProtocol(state, action.payload._id);
      return addProtocol(newState, action.payload);
    default:
      return state;
  }
}

function addProtocol(state: Array<ProtocolEntity>, protocol: ProtocolEntity): Array<ProtocolEntity> {
  return [...state, protocol];
}

function removeProtocol(state: Array<ProtocolEntity>, id: string): Array<ProtocolEntity> {
  return state.filter((protocol) => protocol._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/protocol/protocol.reducer.ts